import { localized } from "@msuite/ui/localization";
import { createColumnHelper } from "@msuite/ui/table";
import { formatInvoiceAmount, formatInvoiceDate } from "@/components/incoming-invoices";
import { OffsetAppliedCell } from "./offset-applied-cell";
import { OffsetPickCell } from "./offset-pick-cell";
import type { OffsetRow } from "./to-offset-rows";

const columnHelper = createColumnHelper<OffsetRow>();

export const columns = [
	columnHelper.accessor("position", {
		id: "position",
		header: "",
		cell: (cell) => <OffsetPickCell row={cell.row.original} />,
		size: 60,
		enableSorting: false,
	}),
	columnHelper.accessor("number", {
		id: "number",
		header: localized("invoices.number"),
		cell: (cell) => cell.getValue(),
		size: 140,
	}),
	columnHelper.accessor("projectName", {
		id: "projectName",
		header: localized("projects.project"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor("creationDate", {
		id: "creationDate",
		header: localized("invoices.creation_date"),
		cell: (cell) => formatInvoiceDate(cell.getValue()),
		size: 120,
	}),
	columnHelper.accessor("sum", {
		id: "sum",
		header: localized("incoming_invoices.payments.offsets.sum"),
		cell: (cell) => formatInvoiceAmount(cell.getValue(), "EUR"),
		size: 130,
	}),
	columnHelper.accessor("openAmount", {
		id: "openAmount",
		header: localized("incoming_invoices.payments.offsets.open_amount"),
		cell: (cell) => formatInvoiceAmount(cell.getValue(), "EUR"),
		size: 130,
	}),
	columnHelper.accessor("appliedAmount", {
		id: "appliedAmount",
		header: localized("incoming_invoices.payments.offsets.applied"),
		cell: (cell) => <OffsetAppliedCell row={cell.row.original} />,
		size: 140,
	}),
];
